export const headerNavItems = [
  { label: '首页', href: '#hero' },
  { label: 'APP下载', href: '#app' },
  { label: '关于我们', href: '#about' },
  { label: '专题合集', href: '#index' },
  { label: '精选推荐', href: '#cards' },
];

export const heroData = {
  tag: '🔥 今日更新 · 海量高清资源',
  slogan: '无需付费 · 无需注册 · 即点即看',
  description: '91在线视频是国内领先的91免费在线视频与91免费视频网站平台，汇聚海量免费电影、免费电视剧、免费综艺、动漫及纪录片等高清影视资源。每日同步更新热播剧目与院线新片，支持多线路智能切换，播放流畅不缓冲，致力于为影视爱好者提供极致的免费在线观看体验。无论你是追剧党还是电影控，都能在这里找到心动内容。',
  stats: [
    { value: '12万+', label: '影视资源' },
    { value: '每日更新', label: '同步热播' },
    { value: '1080P', label: '高清画质' },
  ],
  primaryCta: { label: '开始观看', href: '#cards' },
  secondaryCta: { label: '了解更多', href: '#about' },
};

export const commentsData = [
  {
    id: 1,
    name: '追剧达人小李',
    time: '2小时前',
    content: '用了91在线视频好几年了，资源真的全！最近追的几部热播剧这里都有高清全集，不用到处找了，免费在线视频就认准这家。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20casual%20style%20warm%20lighting%20simple%20background%20professional%20headshot&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    id: 2,
    name: '电影发烧友小王',
    time: '5小时前',
    content: '作为一个电影爱好者，91免费视频网站真的是宝藏。老片新片都有，画质清晰不卡顿，关键是完全免费，已经推荐给身边所有朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20natural%20smile%20minimal%20background%20soft%20lighting%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    id: 3,
    name: '综艺控小陈',
    time: '昨天',
    content: '周末在家用91在线视频刷完了一整季综艺，流畅不缓冲体验太棒了。91麻豆免费视频网站的内容更新速度也很快，每周新综艺同步上线。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20adult%20portrait%20friendly%20expression%20clean%20background%20headshot%20warm%20tone&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
];

export const appData = {
  title: '91在线视频APP',
  subtitle: '随时随地 · 免费高清观影',
  description: '下载91在线视频移动客户端，享受更流畅的观影体验。支持离线缓存、画质切换、投屏播放，让免费在线视频随身而行。覆盖iOS与Android双平台，安装即用，无需注册。',
  features: ['离线缓存', '投屏播放', '画质切换', '夜间模式'],
  imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20video%20streaming%20app%20interface%20with%20movie%20thumbnails%20modern%20flat%20design%20warm%20red%20accent%20dark%20mode%20clean%20UI&width=600&height=400&seq=app-mockup&orientation=portrait',
};

export const cardsData = [
  {
    id: 1,
    title: '热播电视剧专区',
    description: '最新国产剧、韩剧、美剧全集高清在线观看，每日同步更新，追剧不等待。',
    tag: '热门',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20TV%20drama%20scene%20with%20warm%20cinematic%20lighting%20emotional%20actors%20in%20living%20room%20high%20quality%20film%20still%20soft%20bokeh%20background&width=800&height=500&seq=card-tv-01&orientation=landscape',
  },
  {
    id: 2,
    title: '院线电影大全',
    description: '国内外最新电影大片免费看，动作、喜剧、悬疑、爱情类型全覆盖。',
    tag: '新片',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20dramatic%20lighting%20film%20theater%20atmosphere%20silver%20screen%20with%20warm%20golden%20tones%20professional%20cinematography%20shallow%20depth%20of%20field&width=800&height=500&seq=card-movie-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺娱乐合集',
    description: '热门综艺、真人秀、脱口秀一网打尽，周末放松最佳伴侣。',
    tag: '热播',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20lights%20entertainment%20atmosphere%20cheerful%20performers%20vibrant%20set%20design%20warm%20and%20energetic%20mood&width=800&height=500&seq=card-variety-03&orientation=landscape',
  },
  {
    id: 4,
    title: '动漫番剧频道',
    description: '日漫、国漫、欧美动画高清资源，热血、治愈、搞笑番齐全。',
    tag: '推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20art%20style%20scene%20with%20vibrant%20colors%20detailed%20background%20young%20characters%20in%20dynamic%20pose%20warm%20sunset%20lighting%20emotional%20atmosphere&width=800&height=500&seq=card-anime-04&orientation=landscape',
  },
  {
    id: 5,
    title: '纪录片天地',
    description: '自然、历史、科技、人文纪录片精选，拓展知识边界的好选择。',
    tag: '精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20golden%20hour%20lighting%20vast%20landscape%20wildlife%20cinematic%20photography%20warm%20earthy%20tones%20dramatic%20sky&width=800&height=500&seq=card-doc-05&orientation=landscape',
  },
  {
    id: 6,
    title: '少儿动画乐园',
    description: '精选优质少儿动画内容，寓教于乐，给孩子一个安全的观影环境。',
    tag: '亲子',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20playful%20children%20animation%20scene%20with%20cute%20characters%20bright%20cheerful%20colors%20storybook%20style%20warm%20and%20inviting%20atmosphere%20soft%20lighting&width=800&height=500&seq=card-kids-06&orientation=landscape',
  },
];

export const contactData = {
  title: '联系我们',
  subtitle: '意见反馈 · 资源投稿 · 商务合作',
  description: '如果您有好的资源推荐、内容投稿或商务合作需求，欢迎通过以下方式与我们联系。我们重视每一位用户的反馈，期待听到您的声音。',
  email: 'feedback@91onlinevideo.com',
  wechat: '91zaixianshipin',
};

export const updatesData = [
  { id: 1, date: '2026-07-30', content: '《长风渡》全集高清上线，白敬亭宋轶主演古装大剧', tag: '新剧' },
  { id: 2, date: '2026-07-29', content: '暑期档电影专题上线，多部院线新片同步更新中', tag: '专题' },
  { id: 3, date: '2026-07-28', content: 'APP版本更新至v4.2.0，新增智能画质调节功能', tag: '更新' },
  { id: 4, date: '2026-07-27', content: '综艺《奔跑吧》最新季全集上线，欢笑不断', tag: '综艺' },
  { id: 5, date: '2026-07-26', content: '动漫频道新增200+部高清番剧，日漫国漫全覆盖', tag: '上新' },
  { id: 6, date: '2026-07-25', content: '服务器全面升级完成，观影体验更加流畅稳定', tag: '公告' },
  { id: 7, date: '2026-07-24', content: '纪录片《地球脉动》全系列高清修复版上线', tag: '精选' },
];

export const aboutData = {
  title: '关于91在线视频',
  subtitle: '国内领先的91免费在线视频与91免费视频网站',
  description: '91在线视频成立于2019年，始终致力于为广大用户提供免费电影、免费电视剧、免费综艺等丰富多样的免费在线视频资源。我们聚合全网优质影视内容，通过智能分发技术让每一位用户都能快速找到想看的节目。无论是热播国产剧、院线新片还是经典老剧，91国产免费视频平台都能满足您的观影需求。\n\n平台坚持免费策略，不设付费墙，让高品质影视内容触手可及。我们拥有专业的内容运营团队，每日精选推荐，确保用户不错过任何一部好片。91在线视频始终以用户体验为核心，持续优化播放技术与内容库，打造极致的91免费视频网站观影体验。',
  features: [
    { icon: 'ri-movie-line', label: '海量资源' },
    { icon: 'ri-speed-up-line', label: '流畅不卡顿' },
    { icon: 'ri-shield-check-line', label: '安全无广告' },
    { icon: 'ri-smartphone-line', label: '多端同步' },
  ],
};

export const carouselData = [
  {
    id: 1,
    title: '暑期档必看 · 国产剧精选',
    description: '这个夏天最值得追的国产好剧都在这里，每天更新不重样',
    tag: '专题推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20evening%20home%20theater%20setup%20with%20warm%20ambient%20lighting%20cozy%20couch%20large%20screen%20displaying%20movie%20cinematic%20atmosphere%20golden%20hour%20glow%20through%20window&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高分电影 · 口碑佳作合集',
    description: '豆瓣8分以上经典影片一次看个够，每部都值得细细品味',
    tag: '影单推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20film%20projector%20with%20warm%20light%20beam%20in%20dark%20room%20vintage%20cinema%20aesthetic%20dust%20particles%20floating%20in%20light%20dramatic%20atmosphere%20rich%20golden%20tones&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩剧热播 · 甜宠悬疑全覆盖',
    description: '最新韩剧同步更新，高分好评韩剧合集尽在掌握',
    tag: '热门专区',
    imageUrl: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20warm%20autumn%20colors%20couple%20walking%20under%20cherry%20blossoms%20soft%20cinematic%20lighting%20emotional%20atmosphere%20beautiful%20composition&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '动漫盛典 · 热血与治愈',
    description: '从经典老番到最新番剧，动漫爱好者的精神家园',
    tag: '频道精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20cityscape%20at%20sunset%20with%20warm%20orange%20and%20pink%20sky%20cherry%20blossom%20petals%20floating%20detailed%20illustration%20vibrant%20colors%20dreamy%20atmosphere&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '综艺狂欢 · 笑料不断',
    description: '热门综艺全季收录，周末宅家欢乐源泉',
    tag: '热播合集',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20colorful%20TV%20studio%20set%20with%20stage%20lights%20and%20cheerful%20atmosphere%20entertainment%20show%20production%20warm%20vibrant%20colors%20professional%20lighting%20setup&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '纪录片之旅 · 看见世界',
    description: 'BBC、Discovery经典纪录片高清合集',
    tag: '精选内容',
    imageUrl: 'https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20landscape%20of%20mountains%20and%20lakes%20at%20golden%20hour%20documentary%20style%20photography%20warm%20natural%20light%20dramatic%20clouds%20vast%20scenery&width=1200&height=600&seq=carousel-06&orientation=landscape',
  },
];

export const indexData = [
  { id: 1, title: '国产剧热播榜', count: '128部', tag: '热播' },
  { id: 2, title: '韩剧精选集', count: '96部', tag: '推荐' },
  { id: 3, title: '美剧高分榜', count: '85部', tag: '高分' },
  { id: 4, title: '日剧小清新', count: '72部', tag: '清新' },
  { id: 5, title: '动作电影库', count: '210部', tag: '热血' },
  { id: 6, title: '喜剧片合集', count: '156部', tag: '欢乐' },
  { id: 7, title: '悬疑推理馆', count: '93部', tag: '烧脑' },
  { id: 8, title: '爱情电影汇', count: '114部', tag: '浪漫' },
  { id: 9, title: '动漫番剧库', count: '340部', tag: '二次元' },
];

export const rankingData = [
  { id: 1, title: '长风渡', type: '电视剧', hot: '🔥 热度第一', desc: '白敬亭宋轶领衔主演古装大剧' },
  { id: 2, title: '消失的她', type: '电影', hot: '🔥 新片热映', desc: '悬疑反转口碑黑马' },
  { id: 3, title: '奔跑吧·最新季', type: '综艺', hot: '📺 综艺榜首', desc: '王牌综艺欢乐回归' },
  { id: 4, title: '鬼灭之刃', type: '动漫', hot: '⚔️ 动漫热播', desc: '现象级热血番剧' },
  { id: 5, title: '狂飙', type: '电视剧', hot: '💥 经典回顾', desc: '年度口碑爆款剧集' },
  { id: 6, title: '流浪地球2', type: '电影', hot: '🚀 科幻大片', desc: '国产科幻巅峰之作' },
];

export const faqData = [
  {
    id: 1,
    question: '91在线视频真的完全免费吗？',
    answer: '是的，91在线视频平台上的所有影视内容均免费提供，无需充值、无需会员、无需注册即可在线观看。我们通过广告和流量变现维持运营，始终把用户体验放在首位，让免费在线视频真正触手可及。',
  },
  {
    id: 2,
    question: '如何找到我想看的电影或电视剧？',
    answer: '您可以通过首页的搜索功能直接输入片名查找，也可以浏览我们的分类频道，如国产剧、电影、综艺、动漫等。此外，91免费视频网站首页的精选推荐、热度榜单和专题合集也能帮您快速发现好内容。',
  },
  {
    id: 3,
    question: '播放卡顿或加载慢怎么办？',
    answer: '我们为每部影片提供了多条播放线路，您可以在播放器右下角切换不同线路。建议优先选择标注"推荐"的线路。同时，91在线视频APP支持离线缓存功能，可以先下载后观看，避免网络波动影响体验。',
  },
  {
    id: 4,
    question: '91在线视频支持哪些设备观看？',
    answer: '91免费在线视频平台全面支持PC端、手机浏览器、平板以及智能电视投屏观看。您也可以下载91在线视频APP（支持iOS和Android），获得更流畅的移动观影体验，支持画质切换和夜间模式。',
  },
  {
    id: 5,
    question: '资源更新频率如何？新剧什么时候上线？',
    answer: '我们保持与播出平台同步更新，热播剧通常在播出后2-4小时内完成上线。电影、综艺、动漫等内容也会在第一时间更新。平台每日有专业运营团队维护内容库，确保91国产免费视频资源始终新鲜丰富。',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-film-line',
    title: '海量高清资源',
    description: '覆盖电影、电视剧、综艺、动漫、纪录片等全品类，12万+部影视资源免费畅享，每日持续更新。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '多CDN智能加速，自适应码率技术，无论宽带还是移动网络都能获得流畅稳定的播放体验。',
  },
  {
    id: 3,
    icon: 'ri-device-line',
    title: '多端无缝切换',
    description: 'PC、手机、平板、电视投屏全覆盖，一个平台满足所有场景的观影需求，观影记录云端同步。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全纯净体验',
    description: '严格内容审核机制，无恶意弹窗与诱导广告，为全年龄段用户提供安全可靠的免费在线视频环境。',
  },
];

export const mediaData = [
  {
    id: 1,
    title: '《长风渡》精彩片段',
    duration: '03:25',
    views: '128万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20scene%20with%20elegant%20costumes%20warm%20lantern%20lighting%20palace%20interior%20romantic%20atmosphere%20cinematic%20composition%20soft%20golden%20glow&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《奔跑吧》爆笑名场面',
    duration: '05:12',
    views: '96万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20scene%20with%20bright%20sunlight%20groups%20of%20people%20having%20fun%20in%20park%20cheerful%20energetic%20atmosphere%20warm%20vibrant%20colors&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《鬼灭之刃》高燃打斗',
    duration: '02:48',
    views: '215万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20with%20fire%20and%20water%20effects%20warrior%20character%20in%20battle%20pose%20vibrant%20colors%20dramatic%20lighting%20epic%20composition&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const topicsData = [
  { id: 1, name: '#国产剧', count: '3.2万讨论' },
  { id: 2, name: '#韩剧推荐', count: '2.8万讨论' },
  { id: 3, name: '#悬疑片', count: '1.9万讨论' },
  { id: 4, name: '#动漫追番', count: '4.1万讨论' },
  { id: 5, name: '#高分电影', count: '2.5万讨论' },
  { id: 6, name: '#综艺爆笑', count: '1.6万讨论' },
  { id: 7, name: '#纪录片', count: '8.6千讨论' },
  { id: 8, name: '#古装剧', count: '2.2万讨论' },
  { id: 9, name: '#科幻大片', count: '1.3万讨论' },
  { id: 10, name: '#喜剧片', count: '1.1万讨论' },
];

export const footerData = {
  description: '91在线视频是国内领先的91免费在线视频与91免费视频网站平台，提供免费电影、免费电视剧、免费综艺等海量高清影视资源。覆盖91麻豆免费视频网站、91国产免费视频等多元内容，无需付费即可在线观看全集，播放流畅不缓冲。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '首页推荐', href: '#hero' },
        { label: '精选内容', href: '#cards' },
        { label: '热度榜单', href: '#ranking' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '内容分类',
      links: [
        { label: '电影大全', href: '#cards' },
        { label: '电视剧', href: '#cards' },
        { label: '综艺娱乐', href: '#cards' },
        { label: '动漫番剧', href: '#cards' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '最新动态', href: '#updates' },
        { label: 'APP下载', href: '#app' },
      ],
    },
  ],
};